import type { PromoRendererProps } from '@ps-int/promozavr/app/PromoRenderer';

import { countMetrikaRaw } from '../../helpers/metrika';

export const sendPromozavrMetric: PromoRendererProps['sendMetric'] = (...args) => {
    countMetrikaRaw(...args);
};
